export default {
    _prefix: "ManageTemplate",
    labels: {
        title: {
            manage: "Manage Question Templates",
            add: "Add Template Question",
        },
        done: "Done",
        templateName: "Templates",
        questionType: "Question Type",
        favourite: "Favourite Template",
        search: "Search",
        addFavourite: "Add to Favorites",
        addedToFavourites: "Added to Favorites",
        removeFavourite: "Remove from Favorites",
        RemovedFromFavourites: "Removed from Favorites",
    },
};
